import * as types from '../types'

/**
 * 当前提交订单数据
 * @type {Object}
 * data 订单结算明细
 */
const state  = {
    data: {
        carts: {
            skus: [],
            promot_total: 0.00
        },
        tips: {
            isshow: false,
            msg: ''
        }
    },
    final: {
        deliverys_total: 0.00,
        real_amount: 0.00,
        promot_total: 0.00
    }
}

const getters = {

}

const mutations = {
    [types.CHANGE_SETTLEMENT] (state, params) {
        state.data = params
        state.final.deliverys_total = params.carts.deliverys_total
        state.final.real_amount = params.carts.real_amount
        state.final.promot_total = params.carts.promot_total
    },

    //更新金额
    [types.UPDATE_PRICES] (state, params) {
        let discount = 0
        let delivery_fee = 0
        let middle = state.data.carts
        let final = state.final

        /** 商品促销 **/
        for(let i in middle.skus) {
            middle.skus[i]['sku_list'].forEach((sku) => {
                if (sku._promos.length > 0) {
                    let arr = Object.values(sku._promos)
                    let query = arr.shift()

                    switch(query['type']) {
                        case 'number_give': case 'amount_give':
                            break;
                        case 'amount_discount':
                            let amount = parseInt(sku.number * (sku.prices * 100))
                            let number = Math.floor(amount / query['condition'] / 100)

                            discount += parseFloat(query['discount']) * 100 * number
                            break;
                        case 'number_discount':
                            let num = Math.floor(sku.number / query['condition'])

                            discount += parseFloat(query['discount']) * 100 * num
                            break;
                    }
                }
            })
        }

        for(let key in params) {
            //满额立减
            if (params[key]['prom']['type'] == '0') {
                discount += parseInt(params[key]['prom']['discount'] * 100)
            }
            //若优惠为免邮,更新配送费
            if (params[key]['prom']['type'] == '1') {
                console.log('delivery_empty')
            }
        }

        //更新优惠金额
        final.promot_total = (discount / 100).toFixed(2)
        final.deliverys_total = ((parseInt((middle.deliverys_total * 100)) - delivery_fee) / 100).toFixed(2)
        final.real_amount = parseInt(middle.all_prices * 100) + parseInt(final.deliverys_total * 100) - parseInt(final.promot_total * 100)
        final.real_amount = (parseInt(final.real_amount) / 100).toFixed(2)
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/settlement.js